import React, {Component} from "react";
import { observer } from "mobx-react";
import { reaction, observable } from "mobx";
import {createSelectOptions} from "../../../utils/formatar";
import {Col, FormGroup, Input, Label, Row} from "reactstrap";
import DatePicker from "react-datepicker";
import Select from "react-select";
import {motivoContratacaoEnum, statusSolicitacaoConcluidaEnum, statusSolicitacaoEnum} from "../../../utils/enums";
import {Validacao} from "../../comum/components/Validacao";
import TabelaFiltro from "../../comum/components/TabelaFiltro";
import PropTypes from "prop-types";

@observer
export class ContratacoesFiltro extends Component {
    static propTypes = {
        controller: PropTypes.object,
        filtrarStatus: PropTypes.bool,
        limite: PropTypes.number,
        quantidadeTotal: PropTypes.number,
        filtrarSolicitacao: PropTypes.bool
    };
    
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.controller.carregarListaTodosCargos();
    }

    render() {
        const filtros = this.props.controller.filtros;
        const motivoContratacaoOptions = createSelectOptions(motivoContratacaoEnum, "id", "valor");
        const statusOptions = createSelectOptions(statusSolicitacaoConcluidaEnum, "id", "valor");
        return (
            <TabelaFiltro carregarTabela={() => this.props.controller.carregarTabela()} carregarDadosDaUrl={(params) => this.props.controller.carregarDadosDaUrl(params)} filterValues={this.props.controller.filtros} >
                <div>
                    <Row>
                        <Col xs={12} md={6} lg={3}>
                            <FormGroup>
                                <Label>Solicitante</Label>
                                <Input type="text" value={filtros.nomeSolicitante} onChange={(event) => this.props.controller.setNomeSolicitante(event.target.value)} />
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={6} lg={3}>
                            <FormGroup>
                                <Label for="cargo">Cargo</Label>
                                <Select value={this.props.controller.filtros.idCargo}
                                        onChange={(value, options) => this.props.controller.setCargo(value, options)}
                                        options={createSelectOptions(this.props.controller.cargos,"id", "nome")}
                                        noResultsText="Nenhum resultado encontrado"
                                        placeholder="Selecione..."
                                        searchPromptText="Informe nome para pesquisar"/>
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={6} lg={3}>
                            <FormGroup>
                                <Label for="motivo">Motivo contratação</Label>
                                <Select value={filtros.motivo}
                                        options={motivoContratacaoOptions}
                                        onChange={(value) => this.props.controller.setMotivo(value)}
                                        noResultsText="Nenhum resultado encontrado" placeholder="Selecione..."
                                        multi={false} />
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={6} lg={3}>
                            <FormGroup>
                                <Label for="produto">Projeto/centro de resultado/finalidade</Label>
                                <Select value={this.props.controller.produtoSelecionado}
                                        valueKey={"id"}
                                        labelKey={"labelValue"}
                                        onChange={(value, option) => this.props.controller.setProduto(value, option)}
                                        noResultsText="Nenhum resultado encontrado"
                                        placeholder="Selecione..."
                                        searchPromptText="Informe nome para pesquisar"
                                        asyncOptions={(input, callback) => this.props.controller.filtrarProdutos(input, callback)}/>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={6} lg={3}>
                            <FormGroup>
                                <Label for="dataInicial">Data de início</Label>
                                <DatePicker
                                    ref="dataInicio"
                                    onClickOutside={()=>{this.refs.dataInicio.cancelFocusInput(); this.refs.dataInicio.setOpen(false);}}
                                    locale={"pt_BR"}
                                    className="form-control"
                                    dateFormat="DD/MM/YYYY"
                                    selectsEnd
                                    selected={this.props.controller.momentDataInicioFiltro}
                                    startDate={this.props.controller.momentDataInicioFiltro}
                                    endDate={this.props.controller.momentDataFimFiltro}
                                    onChange={(value) => this.props.controller.setMomentDataInicioFiltro(value)}
                                    onChangeRaw={(e) => this.props.controller.setDataInicioCheck(e.target.value)}/>
                                <Validacao id="dataInicio" valor={this.props.controller.dataInicioFiltroValidacao}
                                           tipo={["isDate"]}/>
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={6} lg={3}>
                            <FormGroup>
                                <Label for="dataFinal">Data de término</Label>
                                <DatePicker
                                    ref="dataFim"
                                    onClickOutside={()=>{this.refs.dataFim.cancelFocusInput(); this.refs.dataFim.setOpen(false);}}
                                    locale={"pt_BR"}
                                    className="form-control"
                                    dateFormat="DD/MM/YYYY"
                                    selectsEnd
                                    selected={this.props.controller.momentDataFimFiltro}
                                    startDate={this.props.controller.momentDataInicioFiltro}
                                    endDate={this.props.controller.momentDataFimFiltro}
                                    onChange={(value) => this.props.controller.setMomentDataFimFiltro(value)}
                                    onChangeRaw={(e) => this.props.controller.setDataFimCheck(e.target.value)}
                                />
                                <Validacao id="dataFim" valor={this.props.controller.dataFimFiltroValidacao}
                                           tipo={["isDate"]}/>
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={6} lg={3}>
                            <FormGroup>
                                <Label>Status</Label>
                                <Select value={filtros.status}
                                        options={statusOptions}
                                        onChange={(value) => this.props.controller.setStatus(value)}
                                        noResultsText="Nenhum resultado encontrado" placeholder="Selecione..."
                                        multi={false} />
                            </FormGroup>
                        </Col>
                        {this.props.filtrarSolicitacao &&
                            <Col xs={12} md={6} lg={3}>
                            <FormGroup>
                                <Label>Número da solicitação</Label>
                                <Input
                                    type="number"
                                    value={filtros.numeroSolicitacao}
                                    onChange={(event) => this.props.controller.setNumeroSolicitacao(event.target.value)} />
                            </FormGroup>
                        </Col>
                        }
                    </Row>
                    {this.props.limite && this.props.quantidadeTotal > this.props.limite &&
                        <p style={{color: 'darkorange'}}>Esta página limita um retorno de {this.props.limite} registros por consulta. Sua consulta retornou um total de {this.props.quantidadeTotal} registros, favor refinar sua consulta.</p>
                    }
                </div>
            </TabelaFiltro>
        );
    }
}

